import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import api from '../../../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowDown } from '@fortawesome/free-solid-svg-icons';
import moment from '../../../utils/momentConfig';

const dataChart = {
  labels: ['Congregações'],
  datasets: [
    {
      data: [1],
      backgroundColor: [
        "#25CCF7","#FD7272","#54a0ff","#00d2d3",
        "#1abc9c","#2ecc71","#3498db","#9b59b6","#34495e",
        "#16a085","#27ae60","#2980b9","#8e44ad","#2c3e50",
        "#f1c40f","#e67e22","#e74c3c","#ecf0f1","#95a5a6",
        "#f39c12","#d35400","#c0392b","#bdc3c7","#7f8c8d",
        "#55efc4","#81ecec","#74b9ff","#a29bfe","#dfe6e9",
        "#00b894","#00cec9","#0984e3","#6c5ce7","#ffeaa7",
        "#fab1a0","#ff7675","#fd79a8","#fdcb6e","#e17055",
        "#d63031","#feca57","#5f27cd","#54a0ff","#01a3a4"
      ]
    },
  ],
};

interface CongregationDTO {
  congregation: string;
  list: number;
}

interface Params {
  type: 'member' | 'youth' | 'campaign'
}

const CongregationChart = (params: Params) => {

  const [hasError, setError] = useState<boolean>();
  const chartRef = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [totalCongregations, setTotalCongregations] = useState<number>();

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);

        const { data: congregations } = await api.get(`/congregations/list`, {params: {page: 1, limit: 1}});

        setTotalCongregations(congregations.total);

        if (congregations.total == 0) {
          return;
        }

        const { data } = await api.get(`/congregations/chart/${params.type}`);

        if (!data.success) {
          setError(true);
          return;
        }

        if (!data.item || data.item.length == 0) {
          return;
        }

        dataChart.labels = data.item.map((c: CongregationDTO) => {
          return `${c.congregation}: ${c.list}`;
        });
        dataChart.datasets[0].data = data.item.map((c: CongregationDTO) => {
          return c.list;
        });
      } catch (ex) {
        console.log(ex);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  const handleTitle = () => {
    switch (params.type) {
      case "youth":
        return "Jovens por Congregação";
      case "campaign":
        return "Doadores por Congregação";
      default:
        return "Membros por Congregação";
    }
  };

  const handleExport = () => {
    if (!chartRef.current) return;

    const chart = chartRef.current; 
    const url = chart.toBase64Image();
    
    const a = document.createElement('a');
    a.href = url;
    a.download = `${handleTitle().replace(/\s+/g, '-')}-${moment().valueOf()}.png`;
    a.click();
  };

  return (
    <div className="uk-grid-small" uk-grid="true">
      <div className="uk-width-1@s">
        <h3 className="uk-text-center uk-text-bold">
          {handleTitle()}
          {
            !hasError && dataChart.labels.length > 0 &&
              <FontAwesomeIcon icon={faCircleArrowDown}
                className='uk-text-primary uk-margin-small-left cursor-pointer'
                onClick={handleExport}
                uk-tooltip="title: Exportar Imagem do Gráfico; pos: top"
                size='sm' />
          }
        </h3>
      </div>
      <div className="uk-width-1@m uk-flex uk-flex-center uk-flex-middle">
        {loading && <div className="uk-text-center" uk-spinner="true; ratio:2">Carregando...</div>}
        
        {!loading && <Pie data={dataChart} ref={chartRef} />}

        {totalCongregations === 0 && (
          <span className="uk-label uk-label-warning uk-text-center">
            Nenhuma congregação encontrada
          </span>
        )}

        {(hasError === true) && (
          <span className="uk-label uk-label-danger uk-text-center uk-margin-small-left">
            Gráfico não disponível
          </span>
        )}
      </div>
    </div>
  );
} 

export default CongregationChart;